import{a as t}from"./chunk-EIZTQXKB.js";import{a}from"./chunk-X7UKRW56.js";import{b as m,c as r}from"./chunk-VSZFG2CL.js";import{m as s}from"./chunk-HBP5N4FR.js";s();a();var i=o=>t.dispatch(m(o)).payload,C=o=>t.dispatch(r(o));export{i as a,C as b};
//# sourceMappingURL=chunk-E34CJLUX.js.map
